export const features = {
  credits: process.env.REACT_APP_ENABLE_CREDITS !== 'false',
}
